import "./App.scss";
// import "@progress/kendo-theme-default/dist/all.css";
import React, { useEffect, useState } from "react";
import MapView from "./Site/MapView";
import Login from "./Site/Login";
import { Routes, Route } from "react-router-dom";

import { getXML } from "./dataFetching";
import { Loader } from "@progress/kendo-react-indicators";
import { siteAPI, configAPI } from "./api/axios";
import { useSelector, useDispatch } from "react-redux";
import { setConfigData, setProjectionInfo } from "./redux/setConfigSlice";
import Logout from "./Site/Logout";
import SessionExpired from "./Site/SessionExpired";
import { setAuthChange } from "./redux/toolSelectSlice";

function App() {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const authChange = useSelector((state) => state.toolSelect.authChange);
    const [configLoaded, setConfigLoaded] = useState(false);
    const dispatch = useDispatch();

    const setLayerState = async () => {
        let domain = window.location.hostname.split(".")[0];
        const layers = await getXML(
            `${
                process.env.REACT_APP_CONFIG_BASEURL
            }/${domain}.xml?t=${new Date().getTime()}`
        );
        setConfigLoaded(true);
        dispatch(setConfigData(layers));
    };

    useEffect(() => {
        if (!mapConfig) {
            document.title = "SAM Integrity - Loading";
        } else {
            document.title = `SAM Integrity - ${mapConfig.DisplayName}`;
        }
    }, [mapConfig]);

    useEffect(() => {
        setLayerState();
    }, []);

    useEffect(() => {
        if (authChange) {
            setLayerState();
        } else {
            setAuthChange(false);
        }
    }, [authChange]);

    return (
        <div className="App">
            {!configLoaded && (
                <div>
                    <Loader type="infinite-spinner" />
                </div>
            )}
            {configLoaded && (
                <Routes>
                    <Route path="/sessionexpired" element={<SessionExpired />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<MapView />} />
                </Routes>
            )}
        </div>
    );
}

export default App;
